


import { WatchableValue } from 'neuroglancer/trackable_value';
import { TrackableBoolean } from 'neuroglancer/trackable_boolean';
import { Viewer } from './viewer';

// interface imageTools {
//     showScaleBar: boolean;
//     showLegend: boolean;
//     showStatisticsInfo: boolean;
//     showParameter: boolean;
//     showColorbar: boolean;
//     showHoverInfo: boolean;
// }

export const emptyInvalidImageTools = {
    showScaleBar: new TrackableBoolean(true, true),
    showLegend: new TrackableBoolean(true, true),
    showStatisticsInfo: new TrackableBoolean(true, true),
    showParameter: new TrackableBoolean(false, false),
    showColorbar: new TrackableBoolean(true, true),
    showHoverInfo: new TrackableBoolean(true, true),
    showThumbnail: new TrackableBoolean(true, true)
}

export class TrackableImageTools extends WatchableValue<any> {
    tools = ['showScaleBar', 'showLegend', 'showStatisticsInfo', 'showParameter', 'showColorbar', 'showHoverInfo', 'showThumbnail']
    constructor(public viewer: Viewer) {
        super(undefined);
    }
    toJSON() {
        const obj = {}
        this.tools.forEach((key) => {
            obj[key] = this.viewer[key].value
        })
        return obj
    }
    reset() {
        // this.value = emptyInvalidImageTools;
    }
    restoreState(obj: Object) {
        this.tools.forEach((tool) => {
            if (this.viewer[tool]) this.viewer[tool].value = obj[tool]
        })
    }
}
